import { getAnalytics } from "@tm/insurance/analytics";
import { trackComponentView, trackEvent } from "@tm/insurance/analytics/xdm";

const analytics = getAnalytics();

interface ProductInfo {
  product_list: { id: string }[];
}

/**
 * Listing click / user-action event → Omniture interaction + XDM trackEvent.
 */
export function trackListingClick(
  actionType: string,
  type: string | undefined,
  options?: { components?: ProductInfo[] }
) {
  try {
    analytics?.trackListingEvents({ actionType } as any, "click", type, true);
    trackEvent({
      event_detail: {
        ...(options?.components && { components: options.components }),
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: actionType,
      },
    });
  } catch (err) {
    console.error(`[tracking] ${actionType} failed`, err);
  }
}

/**
 * Listing component-view / shown event → Omniture interaction + XDM componentView.
 */
export function trackListingView(
  actionType: string,
  type: string | undefined,
  componentType = "component"
) {
  try {
    analytics?.trackListingEvents({ actionType } as any, "click", type, true);
    trackComponentView({ name: actionType, type: componentType });
  } catch (err) {
    console.error(`[tracking] ${actionType} failed`, err);
  }
}

/**
 * Omniture-only listing event (no XDM). Used for callbacks passed to shared
 * components that already fire their own XDM events internally.
 */
export function trackListingOmniture(
  event: { actionType: string; payload?: string },
  eventType: string,
  type: string | undefined
) {
  try {
    analytics?.trackListingEvents(event as any, eventType, type, true);
  } catch (err) {
    console.error(`[tracking] ${event.actionType} failed`, err);
  }
}
